export default {
  name: 'pecho-antiviral',
  label: 'pecho antiviral',
  formula: [
    {
      name: 'aceite esencial sándalo',
      quantity: 7.5,
      unit: 'ml',
      ref: 'sandalo'
    },
    {
      name: 'aceite esencial lavanda',
      quantity: 7,
      unit: 'ml',
      ref: 'lavanda'
    },
    {
      name: 'aceite esencial limón',
      quantity: 5,
      unit: 'ml',
      ref: 'limon'
    },
    {
      name: 'aceite esencial bergamota',
      quantity: 4,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial toronja',
      quantity: 15,
      unit: 'ml',
      ref: 'toronja'
    },
  ],
  recipes: [
    {
      name: 'crema pecho antiviral',
      ingredients: [
        {
          name: 'crema de almendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'aceite esencial sándalo',
          quantity: 1.25,
          unit: 'ml',
          ref: 'sandalo'
        },
        {
          name: 'aceite esencial argán',
          quantity: 1.25,
          unit: 'ml',
          ref: 'argan'
        },
        {
          name: 'sinergia pecho antiviral',
          quantity: 2.5,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'loción pecho antiviral',
      ingredients: [
        {
          name: 'agua de rosas',
          quantity: 40,
          unit: 'ml',
        },
        {
          name: 'aguardiente',
          quantity: 30,
          unit: 'ml',
        },
        {
          name: 'sinergia pecho antiviral',
          quantity: 3.75,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'aceite pecho antiviral',
      notes: [
        'aceite de cannabis 15 ml para aplicación reumático.',
        'para aceite base otoño-invierno presindir de la sinergia.'
      ],
      ingredients: [
        {
          name: 'aceite de alendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendas-dulces'
        },
        {
          name: 'aceite de argán',
          quantity: 7.5,
          unit: 'ml',
          ref: 'argan'
        },
        {
          name: 'aceite esencial de sándalo',
          quantity: 7.5,
          unit: 'ml',
          ref: 'sandalo'
        },
        {
          name: 'aceite esencial de avellana',
          quantity: 7.5,
          unit: 'ml',
          ref: 'avellana'
        },
        {
          name: 'sinergia pecho antiviral',
          quantity: 1.25,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'aceite pecho antiviral reumático',
      ingredients: [
        {
          name: 'aceite de alendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendas-dulces'
        },
        {
          name: 'aceite de argán',
          quantity: 7.5,
          unit: 'ml',
          ref: 'argan'
        },
        {
          name: 'aceite esencial de sándalo',
          quantity: 7.5,
          unit: 'ml',
          ref: 'sandalo'
        },
        {
          name: 'aceite esencial de avellana',
          quantity: 7.5,
          unit: 'ml',
          ref: 'avellana'
        },
        {
          name: 'aceite de cannabis',
          quantity: 15,
          unit: 'ml',
          ref: 'cannabis'
        },
        {
          name: 'sinergia pecho antiviral',
          quantity: 1.25,
          unit: 'ml',
        },
      ]
    },
  ]
}
